var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--signin"},[_c('v-container',[_c('v-card',[_c('v-col',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo/disavowl--white.svg"),"alt":""}})]),_c('v-col',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }